module.exports = __webpack_public_path__ + "static/img/platform-icon-2.7efc23c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/platform-icon-2.png
// module id = F60n
// module chunks = 0